<template>
  <div class="mensagem-upgrade-container" v-if="limite || upgrade">
    <div>
      <span v-html="limite ? textoLimite : textoUpgrade" class="aviso_span"> </span>
      <div class="">
        <BotaoPadrao
          arredondadoDireita
          class="botao-padding"
          :nome="limite ? 'ASSESSORIA!' : 'UPGRADE!'"
          icone="bolt"
          cor="vermelho"
          tooltip="Planos RTE"
          :click="linkPlano"
        />
      </div>
    </div>
  </div>

  <!-- <div>
    {{ getUser.id_usuario }}
  </div> -->
  <!-- <div v-if="limite">
    <span class="aviso_span">
      Limite de cadastro máximo de produtos atingido. Contrate o serviço de assessoria para
      monitorar mais produtos.
    </span>
    <div class="upgrade-footer">
      <b-button
        @click="abreLinkUpgrade"
        type="button"
        class="btn btn-upgrade"
        v-b-tooltip.hover
        title="Planos RTE"
      >
        ASSESSORIA! <i class="fa fa-bolt"></i>
      </b-button>
    </div>
  </div>
  <div v-else-if="condition" class="col-md-12">
    <span class="aviso_span">
      Seu limite de
      <b>{{ assinatura_qtde_produto }}</b> produtos cadastrados foi atingido. Atualize seu plano.
    </span>
    <div class="upgrade-footer">
      <b-button
        @click="abreLinkUpgrade"
        type="button"
        class="btn btn-upgrade"
        v-b-tooltip.hover
        title="Planos RTE"
      >
        UPGRADE! <i class="fa fa-bolt"></i>
      </b-button>
    </div>
  </div> -->
</template>

<script>
import { mapGetters } from "vuex";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "MensagemUpgrade",
  components: {
    BotaoPadrao
  },
  props: {
    limite: Boolean,
    upgrade: Boolean,
    textoLimite: String,
    textoUpgrade: String
  },
  computed: {
    ...mapGetters("login", ["getUser"])
  },
  methods: {
    linkPlano() {
      window.open(
        `http://www.econeteditora.com.br/rteplanos/planos.php?p=${btoa(
          `idCliente=${this.getUser.id_usuario}`
        )}`,
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.mensagem-upgrade-container {
  display: flex;
  margin: 15px;
  justify-content: center;
  align-items: center;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid var(--vermelho3);
    background: var(--branco);
  }
}
.aviso_span {
  // border: 1px solid #000;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: var(--vermelho3);
  text-align: center;
}
</style>
